import { useSelector } from 'react-redux';

import { IApplicationState } from '../../types/redux';
import { EJsonQueryPriceType } from '@cian/api-models/common/json_query';

export function usePriceTypeSelector() {
  return useSelector<IApplicationState, EJsonQueryPriceType | undefined>(
    state => state.filters.jsonQuery.price_type?.value,
  );
}
